<template>
  <div class="dashboard">
    <v-alert color="yellow" class="mt-0 title black--text" v-model="snackbar">
      {{ text }}
      <v-btn color="dark-blue" @click="snackbar = false">Ok</v-btn>
    </v-alert>
    <h1 class="pa-2">Dashboard</h1>
    <v-card flat>
      <v-layout row wrap class="white">
        <v-flex xs12 md2 class="pt-1">
          <v-tooltip top>
            <v-btn medium flat router to="activity" slot="activator">
              <v-icon left large>playlist_add</v-icon>
              <h5>Add a Training</h5>
            </v-btn>
            <span>Add a Training</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md3 class="pt-1">
          <v-tooltip top>
            <v-btn medium flat router to="addhrd" slot="activator">
              <v-icon left large>person_add</v-icon>
              <h5>Suggest HRD for Training</h5>
            </v-btn>
            <span text--white>Suggest a participant for a future training</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md2 class="pt-1">
          <v-tooltip top>
            <v-btn medium flat router to="person" slot="activator">
              <v-icon left large>format_list_numbered</v-icon>
              <h5>Trained HRDs</h5>
            </v-btn>
            <span>Lists of all trained HRDs</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md2 class="pt-1">
          <v-tooltip top>
            <v-btn medium flat router to="projects" slot="activator">
              <v-icon left large>assignment_turned_in</v-icon>
              <h5>Added Trainings</h5>
            </v-btn>
            <span text--white>Trainings completed by PWG members</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md3 class="pt-1">
          <v-tooltip top>
            <v-btn medium flat router to="trainers" slot="activator">
              <v-icon left large>people_outline</v-icon>
              <h5>Trainers</h5>
            </v-btn>
            <span>Add trainers for your organisation</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card>
    <v-divider class="pt-1"></v-divider>
    <v-card flat>
      <v-layout row wrap class="white">
        <v-flex xs12 md2 class="pt-1">
          <v-tooltip top>
            <v-btn medium flat router to="profile" slot="activator">
              <v-icon left large>settings</v-icon>
              <h5>Update profile</h5>
            </v-btn>
            <span>Change profile settings</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md3 class="pt-1">
          <v-tooltip top>
            <v-btn medium flat router to="/" slot="activator">
              <v-icon left large>airplay</v-icon>
              <h5>Front Page</h5>
            </v-btn>
            <span text--white>Go to main front page</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md2 class="pt-1">
          <v-tooltip top>
            <v-btn medium flat router to="team" slot="activator">
              <v-icon left large>supervised_user_circle</v-icon>
              <h5>PWG Members</h5>
            </v-btn>
            <span>PWG Members</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md2 class="pt-1">
          <v-tooltip top>
            <v-btn disabled medium flat router to="person" slot="activator">
              <v-icon left large>folder_shared</v-icon>
              <h5>Training Resources</h5>
            </v-btn>
            <span>Training Resources</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 md3 class="pt-1">
          <v-tooltip top>
            <v-btn disabled left medium flat router to="projects" slot="activator">
              <v-icon left large>contact_mail</v-icon>
              <h5>Email Members</h5>
            </v-btn>
            <span text--white>Group Communication to all members</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card>
    <v-divider class="pt-1"></v-divider>
    <v-card flat class="pa-3">
      <div class="black--text pa-2">
        <v-divider></v-divider>
        <v-card row flat v-for="event in meetings" :key="event.id">
          <div class="grey lighten-3 pa-2">
            <h3 v-if="!meeting" centred class="red--text">
              The next PWG meeting is on {{event.eventdate}}
              at {{event.venue}}
              <v-btn fab small v-if="admin" @click="meeting = true">
                <v-icon medium color="indigo">edit</v-icon>
              </v-btn>
            </h3>
          </div>
          <v-divider></v-divider>
          <h2>
            News and Events
            <v-btn medium flat @click="sortBy('eventdate')">
              <v-icon large left color="grey darken-4 white--text">date_range</v-icon>
              <span>Sort by latest</span>
            </v-btn>
            <v-btn medium flat @click="rdialog = true">
              <v-icon large left color="indigo white--text">add_circle</v-icon>
              <span>Add News/Event</span>
            </v-btn>
          </h2>
          <v-layout row wrap class="white" v-if="meeting">
            <v-flex xs12 md4 class="white pa-2">
              <v-menu v-model="datemenu" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :rules="inputRules"
                  :value="formattedDate"
                  clearable
                  label="Next Meeting date"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="eventdate" @click="datemenu = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md4 class="white pa-2">
              <v-text-field
                prepend-inner-icon="house"
                :counter="50"
                v-model="venue"
                label="Venue"
                hint="Venue of the next meeting"
                :rules="inputRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 class="white pa-2">
              <v-btn fab small class="teal darken-5 white--text" @click="updateMeeting">
                <v-icon large left color="white white--text">save</v-icon>
                <span>Save</span>
              </v-btn>
              <v-btn fab small class="teal darken-5 white--text" @click="meeting=false">
                <v-icon large color="white white--text">close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-divider class="grey darken-2 pa-1"></v-divider>
        <v-dialog v-model="rdialog" max-width="400">
          <v-card class="pa-3">
            <v-card-title class="headline grey darken-3 white--text">New Updates/Event</v-card-title>
            <v-form ref="form" v-model="valid" lazy-validation class="pt-2">
              <v-text-field
                outline
                v-model="title"
                :counter="50"
                hint="Short Title"
                label="Add a Title"
                required
              ></v-text-field>
              <v-textarea
                v-model="content"
                label="Detailed Description"
                counter
                maxlength="500"
                full-width
                single-line
                outline
              ></v-textarea>
              <v-menu v-model="menu" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :rules="inputRules"
                  :value="formattedDate"
                  clearable
                  label="Event Start date"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="eventdate" @change="menu = false"></v-date-picker>
              </v-menu>
              <v-text-field
                outline
                v-model="host"
                :counter="50"
                hint="Lead Organization"
                label="Main Organising partner"
                required
              ></v-text-field>
              <v-text-field
                outline
                v-model="website"
                :counter="50"
                label="Url to online source (website, Social media, blog)"
                required
              ></v-text-field>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="indigo darken-4 white--text" @click="updateEvents">Submit</v-btn>

              <v-btn color="indigo darken-4 white--text" @click="rdialog = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <v-layout wrap column v-if="approved">
        <v-flex xs12 md4 class="white pa-2" v-for="event in events" :key="event.id">
          <v-card dark color="white black--text pa-3">
            <h2 class="black--text pa-2">{{event.title}}</h2>
            <h3 class="grey lighten-5 pl-3 pt-1 pb-1 red--text">{{event.eventdate}}</h3>
            <span class="subheading font-weight-light pa-1">{{event.content}}</span>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { db, auth, functions } from "@/fb";
import format from "date-fns/format";
export default {
  data() {
    return {
      events: [],
      reference: "",
      admin: false,
      userid: "",
      members: [],
      userdata: [],
      theme: "complete",
      detail: false,
      title: "",
      content: "",
      result: "",
      text:
        "To add participants to the database, Please click on ADD TRAINING button below to enter data manualy. Alternatively send the participant list to ict@hrdcoalition.org for assistance",
      rdialog: false,
      datemenu: false,
      meetingdate: "",
      venue: "",
      snackbar: true,
      meeting: false,
      meetings: [],
      eventid: "",
      valid: "",
      eventdate: "",
      website: "",
      host: "",
      newdate: "",
      menu: false,
      approved: false,
      inputRules: [
        v => !!v || "This field is required",
        v => v.length >= 5 || "Minimum length is 6 characters"
      ]
    };
  },
  watch: {
    updatedData() {
      return this.meetings.filter(item => {
        return item.venue === this.venue;
      });
    }
  },
  methods: {
    updateEvents() {
      db.collection("events")
        .add({
          title: this.title,
          content: this.content,
          eventdate: format(this.eventdate, "Do MMM YYYY"),
          approved: "false",
          website: this.website
        })
        .then(docRef => {
          this.rdialog = false;
          this.success = true;
          this.title = "";
          this.content = "";
          this.eventdate = "";
          this.approved = false;
        });
    },
    updateMeeting() {
      if (this.eventdate != "" && this.venue != "") {
        this.newdate = format(this.eventdate, "Do MMM YYYY");
        this.meeting = false;
        db.collection("meetings")
          .doc(this.eventid)
          .update({
            title: auth.currentUser.uid,
            venue: this.venue,
            eventdate: this.newdate
          })
          .then(() => {
            db.collection("meetings").onSnapshot(res => {
              const changes = res.docChanges();
              this.meetings = [];
              changes.forEach(change => {
                if (change.type === "added") {
                  this.eventid = change.doc.id;
                  this.venue = change.doc.data().venue;
                  this.meetings.push({
                    ...change.doc.data(),
                    id: change.doc.id
                  });
                }
              });
            });
          });
      }
    },
    sortBy(prop) {
      this.events.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
    }
  },
  watch: {},
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    } else {
      this.userid = auth.currentUser.uid;
    }
    db.collection("events").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.approved = change.doc.data().approved;
          if (this.approved == true) {
            this.events.push({
              ...change.doc.data(),
              id: change.doc.id
            });
          }
        }
      });
    });

    db.collection("meetings").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.eventid = change.doc.id;
          this.venue = change.doc.data().venue;
          this.meetings.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });

    db.collection("members")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.id === this.userid) {
            const data = {
              id: doc.id,
              name: doc.data().name,
              userlevel: doc.data().userlevel
            };
            this.userdata.push(data);
            this.admin = doc.data().userlevel;
          }
        });
      });
  },
  computed: {
    formattedDate() {
      return this.eventdate ? format(this.eventdate, "Do MMM YYYY") : "";
    }
  }
};
</script>
<style scoped>
.rounded {
  border: solod;
  border-color: grey;
  border-radius: 50px;
}
</style>
